var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BinartIconWrapper, BinartInlineWrapper, BinartLabel, HiddenCheckbox } from './subcomponents';
const Binart = (_a) => {
    var { className, disabled, hasError, icon, id, isSelected, label, labelProps, onClick, binartRef } = _a, props = __rest(_a, ["className", "disabled", "hasError", "icon", "id", "isSelected", "label", "labelProps", "onClick", "binartRef"]);
    return (_jsxs(BinartLabel, Object.assign({ id: `${id}-label`, className: className }, labelProps, { children: [_jsx(BinartInlineWrapper, Object.assign({ className: "binart-label", isSelected: isSelected }, { children: label })), _jsx(HiddenCheckbox, Object.assign({}, props, { disabled: disabled, checked: isSelected, onChange: onClick, ref: binartRef })), _jsx(BinartIconWrapper, Object.assign({ className: "binart-icon-wrapper", id: `${id}-icon-wrapper`, hasError: hasError, disabled: disabled, isSelected: isSelected }, { children: icon }))] })));
};
export default Binart;
//# sourceMappingURL=Binart.js.map